/*    
<summary>
  This functional component "DeleteAllPopup" renders a confirmation modal for deleting all items.
  1. Displays a modal dialog with confirmation and cancel options.
  2. Uses "modalSubmit" to trigger the delete action.
  3. Uses "modalClosed" to close the modal.
  4. Shows loading state on confirm button using "isLoading".
  Developer: Chandan Singh, Created Date: 30-April-2026
</summary>
<returns>Returns JSX</returns>
*/

import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import LoaderButton from '../../../shared/components/Button/LoaderButton';
import { FormattedMessage } from 'react-intl';

interface Props {
    modalSubmit: () => void;
    modalClosed: () => void;
    isLoading: boolean;
}

const DeleteAllPopup: React.FC<Props> = props => {
    return (
        <Modal show={true} centered onHide={props.modalClosed} dialogClassName="delete-popup">
            <Modal.Header closeButton>
                <Modal.Title>
                    <FormattedMessage id='Application_Title' />
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="bootbox-body">
                    <FormattedMessage id='Message_Delete_Selected_Confirm' />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <LoaderButton
                    type="submit"
                    onClick={props.modalSubmit}
                    isLoading={props.isLoading}
                    text="Button_Confirm"
                />
                <Button
                    variant="primary"
                    onClick={props.modalClosed}
                    className="btnOkSize"
                >
                    <FormattedMessage id='Button_Cancel' />
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default DeleteAllPopup;